import React from 'react';
import { Text, Skeleton, Flex } from '@landr/maestro';
import { defaultRowContainer } from '../SamplesTablePlayer/SamplesTablePlayer.styled';
import { SamplesTableBpmProps } from './SamplesTableBpm.types';

export const SamplesTableBpmSkeleton = () => (
    <Flex className={defaultRowContainer}>
        <Flex width="sm">
            <Skeleton width="xs" height="xs" />
        </Flex>
    </Flex>
);

export const SamplesTableBpm: React.FC<SamplesTableBpmProps> = ({ bpm }) => (
    <Text textStyle="body-sm" color="text.medium">
        {bpm}
    </Text>
);
